module.exports = __webpack_public_path__ + "img/card-corner-pc.0e6aea8f.svg";